import httpCommon from "./http-common";

// Get exception queue
const getExceptionQueue = (businessId: number, status?: string) => {
  const params = status ? `?businessId=${businessId}&status=${status}` : `?businessId=${businessId}`;
  return httpCommon.get(`/v1/get/exceptionQueue${params}`);
};

// Create new exception
const createException = (data: any) => {
  return httpCommon.post("/v1/add/exceptionQueue", data);
};

// Resolve exception
const resolveException = (exceptionId: number, data: any) => {
  return httpCommon.put(`/v1/update/exceptionQueue/${exceptionId}`, data);
};

// Get exception by ID
const getExceptionById = (id: number) => {
  return httpCommon.get(`/v1/get/exceptionQueue/${id}`);
};

// Assign exception to user
const assignException = (exceptionId: number, userId: number) => {
  return httpCommon.put(`/v1/assign/exceptionQueue/${exceptionId}`, { assignedTo: userId });
};

// Escalate exception
const escalateException = (exceptionId: number, data: any) => {
  return httpCommon.put(`/v1/escalate/exceptionQueue/${exceptionId}`, data);
};

// Get exception statistics
const getExceptionStatistics = (businessId: number) => {
  return httpCommon.get(`/v1/get/exceptionQueue/statistics/${businessId}`);
};

// Bulk resolve exceptions
const bulkResolveExceptions = (exceptionIds: number[], resolutionData: any) => {
  return httpCommon.put("/v1/bulk/resolve/exceptionQueue", {
    exceptionIds,
    ...resolutionData
  });
};

const ExceptionQueueService = {
  getExceptionQueue,
  createException,
  resolveException,
  getExceptionById,
  assignException,
  escalateException,
  getExceptionStatistics,
  bulkResolveExceptions,
};

export default ExceptionQueueService; 